import React, { FC, useMemo } from 'react'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import { Grid } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import { AttacheCommercial, GestionnaireLocatif } from '../types/detailsContactTypes'
import { isEmpty } from 'lodash'
import Link from '../../../components/link/Link'
import { useLocation } from 'react-router'
import { DetailsContactStateType } from '../DetailsContact'

interface InformationsAcGlProps {
	contact?: GestionnaireLocatif | AttacheCommercial
}

const InformationsAcGl: FC<InformationsAcGlProps> = ({ contact }) => {
	const intl = useIntl()
	const { classes, cx } = useStyles()
	const location = useLocation()
	const state = location.state as DetailsContactStateType

	const hasContactInfo = useMemo(() => !!contact && !isEmpty(contact), [contact])

	const textStyle = cx(
		classes.text1,
		classes.textStyle
	)

	return (
		<Grid container item flexDirection="column">
			<Grid item className={textStyle}>
				{
					hasContactInfo ?
						`${contact?.prenom} ${contact?.nom}`
						:
						<FormattedMessage
							id="detailsContact.informations.default.nom"
							defaultMessage="Numéro d'appel YouFirst"
							description="Numéro d'appel YouFirst"
						/>
				}
			</Grid>
			<Grid item className={textStyle}>
				{
					hasContactInfo ?
						contact?.telephone
						:
						<FormattedMessage
							id="detailsContact.informations.default.telephone"
							defaultMessage="01 40 40 18 50"
							description="01 40 40 18 50"
						/>
				}
			</Grid>
			{
				hasContactInfo &&
				<Link
					textStyle="text1"
					hasChevron={false}
					href={`mailto:${contact?.email}?subject=${intl.formatMessage({ id: 'detailsContact.informations.default.objet' }, { prenom: state?.prenom, nom: state?.nom })}`}
					flex={false}
					noAnimation
					style={{
						fontWeight: 700,
						lineHeight: '32px',
						textDecoration: 'none'
					}}
				>
					{contact?.email}
				</Link>
			}
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	textStyle: {
		fontWeight: 700,
		lineHeight: '32px'
	}
}))

export default InformationsAcGl